import React from 'react'
import Modal, { Styles } from 'react-modal'
import { modalStyles } from './index'
import { BrandMark, CustomImage, Footer } from '../elements'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { intercomCompanyState } from '../../store/data'

const LoadingModal = () => {
  const { imageMedium } = useRecoilValue(intercomCompanyState)
  const { t } = useTranslation()
  return (
    <Modal
      isOpen
      style={modalStyles as Styles}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <div className="w-56 h-56 relative m-auto mt-6">
        <div className="w-56 h-56 absolute left-0 top-0 right-0 bottom-0 m-auto border-8 border-accent border-t-primary rounded-full animate-spin" />
        <div className="w-36 h-36 absolute left-0 top-0 right-0 bottom-0 m-auto z-10 rounded-full overflow-hidden bg-accent flex items-center justify-center">
          <CustomImage
            src={imageMedium}
            alt="Loading"
            defaultIcon={<BrandMark classes="text-xl" />}
          />
        </div>
      </div>
      <div className="font-heading font-bold my-4 mx-6 text-center grow text-foreground">
        {t('connecting')}
      </div>
      <Footer />
    </Modal>
  )
}

export default LoadingModal
